import { useEffect, useRef, useState, VFC } from 'react'
import { Link, LinkProps } from 'src/elements/Link'
import { black, truewhite } from 'src/styles/colors'
import { fontWeightBold, fontWeightRegular } from 'src/styles/font'
import {
  APP_LP_URL,
  APP_REQUEST_INFORMATION_URL,
  ARTICLES,
  CHIRA_CEO_CASE_URL,
  CHIRA_CEO_URL,
  COMPANY,
  CONTACT,
  EVENTS_URL,
  HIRING_URL,
  NOTE_URL,
  SIGN_IN,
  STORIES,
  STORIES_FEATURE,
  STORIES_NEW,
  STORIES_POPULAR,
} from 'src/utils/routes'
import styled, { css } from 'styled-components'

type SideMenuItemListProps = {
  title: string
  items: {
    href: string
    label: string
  }[]
}

const INTERVIEW: SideMenuItemListProps = {
  title: '決裁者インタビュー',
  items: [
    {
      href: STORIES,
      label: 'インタビュー記事を検索',
    },
    {
      href: STORIES_NEW,
      label: '新着記事',
    },
    {
      href: STORIES_POPULAR,
      label: '人気記事',
    },
    {
      href: STORIES_FEATURE,
      label: '特集記事',
    },
  ],
}

const SERVICE: SideMenuItemListProps = {
  title: 'サービス概要',
  items: [
    {
      href: APP_LP_URL,
      label: '決裁者のための経営相談・発注先探しサービス「ONLYSTORY」',
    },
    {
      href: CHIRA_CEO_URL,
      label: '決裁者限定マッチングプラットフォーム「チラCEO」',
    },
    {
      href: EVENTS_URL,
      label: '『ONLYSTORY』会員様限定イベント',
    },
    {
      href: CHIRA_CEO_CASE_URL,
      label: '利用したお客様からの声',
    },
  ],
}

export const ABOUT: SideMenuItemListProps = {
  title: '運営会社',
  items: [
    {
      href: COMPANY,
      label: '会社概要',
    },
    {
      href: HIRING_URL,
      label: '採用情報',
    },
    {
      href: NOTE_URL,
      label: '代表平野のnote一覧',
    },
    {
      href: ARTICLES,
      label: 'お知らせ',
    },
  ],
}

export const SIDE_MENU_ID = 'sidemenu'
export const SideMenu: VFC = () => (
  <nav>
    <SideMenuList id={SIDE_MENU_ID}>
      <SideMenuItemList {...INTERVIEW} />
      <SideMenuItemList {...SERVICE} />
      <SideMenuItemList {...ABOUT} />
      <SideMenuItemLink href={CONTACT}>お問い合わせ</SideMenuItemLink>
      <SideMenuItemLink href={APP_REQUEST_INFORMATION_URL}>
        資料請求する
      </SideMenuItemLink>
      <SideMenuItemLink href={SIGN_IN}>ONLYSTORYにログイン</SideMenuItemLink>
    </SideMenuList>
  </nav>
)

const SideMenuItemList: VFC<SideMenuItemListProps> = ({ title, items }) => {
  const listRef = useRef<HTMLUListElement>(null)
  const [isMenuOpen, setMenuOpen] = useState(true)
  const [listHeight, setListHeight] = useState<number | undefined>(undefined)
  useEffect(() => {
    if (!listRef.current) return
    setListHeight(listRef.current.clientHeight)
    setMenuOpen(false)
  }, [listRef])
  return (
    <li>
      <button onClick={() => setMenuOpen(!isMenuOpen)}>{title}</button>
      <SubMenuList ref={listRef} height={isMenuOpen ? listHeight : 0}>
        {items.map(({ href, label }) => (
          <li key={label}>
            <Link href={href}>{label}</Link>
          </li>
        ))}
      </SubMenuList>
    </li>
  )
}
const SideMenuItemLink: VFC<LinkProps> = ({ children, ...props }) => (
  <li>
    <Link {...props}>{children}</Link>
  </li>
)

export const SIDE_MENU_WIDTH = '240px'
const SideMenuList = styled.ul`
  position: fixed;
  top: 0;
  right: -${SIDE_MENU_WIDTH};
  width: ${SIDE_MENU_WIDTH};
  height: 100vh;
  padding: 0 24px 10px;
  background: ${black};
  overflow-y: auto;
  transition: right 0.5s ease-in-out;
  > li {
    transition: all 0.3s ease-in-out;
    color: ${truewhite};
    font-size: 14px;
    font-weight: ${fontWeightBold};
    overflow: hidden;

    > button,
    > a {
      display: block;
      width: 100%;
      padding: 20px 0px;
      border-bottom: 0.5px solid;
    }
  }
`

const SubMenuList = styled.ul<{ height?: number }>`
  border-bottom: 0.5px solid;
  transition: all ease-in-out 0.5s;
  padding: 0 15px;
  > li {
    border-bottom: 0.5px solid;
    font-size: 12px;
    font-weight: ${fontWeightRegular};
    a {
      display: block;
      padding: 14px 0;
    }
    :last-child {
      border: none;
    }
  }
  ${({ height }) =>
    height != null &&
    css`
      height: ${height}px;
      ${height === 0 && 'border-bottom: 0px;'}
    `}
`
